import { Component } from '@angular/core';
import { ModalService } from '../../../utils/modal.service';
import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';
import { DialogModule } from "primeng/dialog";

@Component({
    standalone: true,
    selector: 'app-global-modal',
    templateUrl: './global-modal.component.html',
    imports: [ButtonModule, CommonModule, DialogModule],
})
export class GlobalModalComponent {

    constructor(public modalService: ModalService) { }

    close(): void {
        this.modalService.close();
    }
}